var map = {
	"./module-1/en/module-thumb.jpg": "36f4",
	"./module-1/th/module-thumb.jpg": "ccd0",
	"./module-2/en/module-thumb.jpg": "f9aa",
	"./module-2/th/module-thumb.jpg": "c015",
	"./module-3/en/module-thumb.jpg": "2ea6",
	"./module-3/th/module-thumb.jpg": "43a3",
	"./module-4/en/module-thumb.jpg": "bc9a",
	"./module-4/th/module-thumb.jpg": "a84f",
	"./module-5/en/module-thumb.jpg": "0470",
	"./module-5/th/module-thumb.jpg": "3fe7",
	"./module-6/en/module-thumb.jpg": "092c",
	"./module-6/th/module-thumb.jpg": "12c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ee55";